import { Injectable } from "@angular/core";
import { PureCloudModel } from "app/_models/pure-cloud.model";
import { environment } from "environments/environment";
import { forkJoin, Subject } from "rxjs";
import * as PMMessage from './../_constants/pure-cloud';
import { takeUntil } from 'rxjs/operators';
import { CATEGORY_CONNECT, DIRECTION_INBOUND, PM_GET_DOSSIER_DATA, STATE_CONNECTED } from "./../_constants/pure-cloud";
import { ResetState, SetDossier, SetInsuree, SetPolicy, SetPureCloudInfo } from "app/_actions/intake.actions";
import { Store } from "@ngxs/store";
import { CommonService } from "app/reusable/common.service";
import { Insuree } from "app/_models/insuree.model";
import { DialogCloseResult, DialogService } from "@progress/kendo-angular-dialog";
import { DossierGenesysFiltredComponent } from "app/dossier/dossier-genesys-filtred/dossier-genesys-filtred.component";
import { ClientService } from "app/support/organizationUnits/clients/client.service";
import { PolicyControl } from "app/_models/policycontrol.model";
import { PureCloudInfo } from "app/_models/pureCloudInfo";
export const PFE_ORIGIN = environment.Services.myPureCloudApp;


@Injectable({
    providedIn: 'root'
})
export class PureCloudService {
    public serverUrlSlot1 : string = environment.Services.AlphaURLSlot1;
    public serverUrlSlot2 : string = environment.Services.AlphaURLSlot2;
    private actionSource = new Subject();
    private actions$ = this.actionSource.asObservable();
    private notificationSource = new Subject();
    private notifications$ = this.notificationSource.asObservable();
    private pureCloud = new  PureCloudModel();
    private _subject$: Subject<boolean> = new Subject();
    private InsureeData: Insuree = new Insuree();
    constructor(private store: Store,
                private commonService: CommonService,
                private clientSpecificInfoService:  ClientService,
                private dialogService :DialogService) {
        window.addEventListener('message', (ev: MessageEvent) => {
            if (ev.origin != PFE_ORIGIN) return;

            switch (ev.data.type) {
                case PMMessage.PM_INITIAL_SETUP:
                    this.notificationSource.next(ev.data);
                    break;
                case PMMessage.PM_INTERACTION_STATE_CHANGE:
                    this.notificationSource.next(ev.data);
                    break;
                case PMMessage.PM_SCREEN_POP:
                    this.notificationSource.next(ev.data);
                    break;
                case PMMessage.PM_CALL_LOG:
                    this.notificationSource.next(ev.data);
                    break;
                case PMMessage.PM_USER_STATUS_CHANGE:
                    this.notificationSource.next(ev.data);
                    break;
                case PMMessage.PM_GET_DOSSIER_DATA:
                    this.notificationSource.next(ev.data);
                    break;
                default:
                    console.log(`Invalid data from window.postMessage: ${JSON.stringify(ev)}`);
            }
        });
    }

    public get actions() { return this.actions$; }

    public get notifications() { return this.notifications$; }

    public handelCall(data, editMode )
    {
        this.pureCloud = data;
        if( this.pureCloud &&  this.pureCloud.type == PM_GET_DOSSIER_DATA &&  this.pureCloud.category == CATEGORY_CONNECT)
        {
           if( this.pureCloud.interaction)
           {
             if( this.pureCloud.interaction.state == STATE_CONNECTED &&  this.pureCloud.interaction.direction == DIRECTION_INBOUND)
             {
                if(!this.pureCloud.interaction.attributes && this.pureCloud.interaction.phone != undefined)
               {
                this.handelNewCase(this.pureCloud.interaction);
               }
               else
               {
                this.handelExistingCase(editMode);
               }
             }
           }
        }
    }

    public handelNewCase(interaction)
    {
        if(!document.hidden)
        {
            let GetContactInitiationTypesUrl: string = 'ContactInitiationType/GetAll';
            var clientSpecificInfo = {"CsiVdnnumber":interaction.calledNumber.replace('+','')}
            this.store.dispatch(new ResetState()).pipe(takeUntil(this._subject$)).subscribe(
                (data:any)=>
                {  forkJoin([
                    this.clientSpecificInfoService.getByDnisNumber(clientSpecificInfo),
                    this.commonService.getData(GetContactInitiationTypesUrl, this.serverUrlSlot1,true)])
                    .pipe(takeUntil(this._subject$))
                    .subscribe((results: any[]) => {
                        if(interaction.phone != undefined){
                            let contactInitiation = results[1].find(c=>c.citName == 'Telephone');
                            let ouId = results[0];
                            let pureCloudInfo = new PureCloudInfo();
                            pureCloudInfo.contactInitiation = contactInitiation;
                            pureCloudInfo.ouId = ouId;
                            pureCloudInfo.phone = interaction.phone.replace('tel:+','');
                            this.setPureCloudInfo(pureCloudInfo)
                        }
                    });
                }
            );
        }

    }

    setPureCloudInfo(pureCloudInfo){
        this.store.dispatch(new SetPureCloudInfo(pureCloudInfo)).pipe(takeUntil(this._subject$)).subscribe();
    }

    setInsureeContactInitiation(contactInitiation){
        if(contactInitiation != undefined){
            this.InsureeData.ipaContactInitiation =contactInitiation.citId;
            this.InsureeData.ipaDateOfBirth =null;
          this.InsureeData.ipaContactTelephone = this.pureCloud.interaction.phone.replace('tel:+','');
          this.store.dispatch(new SetInsuree(this.InsureeData)).pipe(takeUntil(this._subject$)).subscribe();
        }
    }

    setClientId(ouId){
        if(ouId != null){
            let policyControl = new PolicyControl()
            policyControl.client.id = ouId;
            this.store.dispatch(new SetPolicy(policyControl,true)).pipe(takeUntil(this._subject$)).subscribe();
        }
    }

    public handelExistingCase(editMode)
    {
        if(!document.hidden)
        {
                let caseNumber =this.pureCloud.interaction.attributes.casenumber;
                let GetContactInitiationTypesUrl: string = 'ContactInitiationType/GetAll';
                let getDossierUrl: string = `Dossier/GetByNumber/` + caseNumber;
                forkJoin([
                    this.commonService.getData(getDossierUrl, this.serverUrlSlot2),
                    this.commonService.getData(GetContactInitiationTypesUrl, this.serverUrlSlot1,true)]
                    ).pipe(takeUntil(this._subject$)).subscribe((results: any[]) => {
                        if(results[0].length>1)
                        {
                            const dialogRef = this.dialogService.open({
                                content:  DossierGenesysFiltredComponent,
                                width: "80%"
                            });
                            dialogRef.content.instance.dossierListFiltred = results[0];
                            dialogRef.result.subscribe((result: any) => {
                                if (!(result instanceof DialogCloseResult)) {

                                }
                            });
                        }
                        else
                        {
                          this.open(results[0][0].dossierId, editMode)
                        }
                    });
        }
    }

    public open(dossierId, editMode) {
        let GetDossierUrl: string = `Dossier/GetById/` + dossierId;
        this.commonService.getData(GetDossierUrl, this.serverUrlSlot2).pipe(takeUntil(this._subject$))
          .subscribe(
            (data: any) => {
              this.store.dispatch(new SetDossier(data, editMode));
            });
      }
}
